import { Injectable } from '@angular/core';
import * as moment from "moment";
import { IPenalty } from "libraries/service/resources/hotel/IResourceHotel";

@Injectable()
export class CancellationPipesService {

    public isFuture(date: string): boolean {
        return moment(date).isAfter();
    }

    public isFreePenalty(penalty: IPenalty): boolean {
        return (!penalty.total || !penalty.total.cost) && !penalty.percentage;
    }
}